<template>
  <div class="main">
    <div class="recharge">
      <div class="MuiBox-root jss228">
        <div class="jss202">
          <ul class="MuiList-root">
            <!-- <li
              class="MuiListItem-root jss203"
              :class="isispayment == 4 ? 'jss211' : ''"
              @click="ZFBHPJpayment"
            >
              <div class="MuiBox-root jss243 jss204">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAACqVBMVEUAAAAAqu8Am9oAqu8Aqu8BltQBlNQAoeIBnt4BltMBltQAoeIBnt4BltQAqu8Aqu8Aqu8AoeIBnt4Aqu8Aqu////8BltT///0Aqu4CqvABnt7///sAq+8AoeIApev///kAqvEApe8Ep+vt+vwAq/Cw5PIut+0AqfAApe0ApO/8/vv+//4Bp/EAo/AAqe8Bq+0ApO0Ap+8AqO0Aq/JJvvABqu3//f7+/v37/v0ArOv//vz3/Pv///j9/vid3vfm9vUBqe4AquwApOn//v/9//zy+fgAp/QApPQAofIAoe4Ao+sAoOskr+f9///9/f70/PyX3fW+6PIApfK25PEApPFIvvAAre5gxe0ZqOhFvuXg4eDz+/vy+/n0+/jr9/j4/ffY8PTH6/Sy4vMAqvOo4fCc2+6P1ew1tewArewhresDqes1uOoqr+oLqOo6tul9zugTrOcMp+cCpucBouX8///3/f38/Pzv+fro9vn6/vjk9ffK6/bh8/XN6vS35vKi3vIAqPLC6PEArfGA0e4Tq+1kyOxbw+wZrOwJp+x50OsgsusLrOsAoutDveqB0eluyOlHvelmw+css+cRqecAn+br+frc8vkAqPXa8fTN7/PQ7vMBqfOt5fKr4PLK6/GP0/EAnvGy5fCK1vAArfCw4O8Ane+I1e5Mv+5Cu+1Iuu0FqO2U1ux4yOtUxOtQvutIvOs/uOsksusEresAp+tGv+ovuOpFt+pLwekMpOloyugvtugys+iFz+dexedQwuZJu+YNq+YAq+ZPveUKp+IAouIssOH9+/oAovre9PWb3/Xs9vTC6/MAm/PT6vGT3fE4uO+03u6M2+0Mp+2u4uyNzeyX2euQ1+tgwuur3+ql2+p0zeqL0+UCo+M1t+JaweDK2dyzzNgSl9IroM131JcAAAAAFHRSTlMA/SuVBpD8+fj02NfX1L27mI+OCXGCc30AAATCSURBVEjHlZaFd9NAHMeLu99xCRciEEgqq9JV1tK1c2fCBHef4+7u7u7u7u7uDn8Jl3ZjdN0D+nl9fS/fd5/kd7kkv1Mp1G7dtGG7f9CwaevaqgB169QC/0Wtlm3841uA/6Z5XSLUAWFQh9RfKxyhVm1Vq5py2SjLRhOgQAj1VE1CMsvBRUXLly+5tpCpQWisahCSGYSRnt5xcVHFyXSoUF/VPiQbpj/mRgjBy0l86CXaVgoMA6gKGHn/GKS1oaVmuiIBDkN1gUDzdABeXhIFYSSaJU+vTCw8iA4WGEnXoZIRvuNE0MLLt39HZR0AEyRIJ4VnnSrZPChzLIQI9xv0O9pxThCDBN1J+fSajpWM6+nWwjRNVFUSdyHHwvwpUIx1UedKzqxc4S/p0KjfydDZdPAcqJnWaJOcoBYIanb7yN4IpsEF27MEBVY2ySZRX+0u6YHFcooNsKeoF7lLsHh14NDH8mRB6GoCoE6deDOtq8KDpwM0EELuyeCuXbspvEjViTWsg1D0MFbjZ8KYnhkZGT3H2Cf05TDG3Pr86VSoQEslB/Z1qaC7Qpd9BV8nK5cakghqEKhcJlmdExGhDvzUyt/js30RhBnXEnhQXZCsosNnFNRq2Szrd9H0Jl5iRImdxsXGwEkl0frqAjVsXeL8E8cLCgqKRq1i1ayZsXoNBuGiBzmdeFaEeXp1wZQ8/EL22nG9e/bqs3bSoAXnFnZIyjHpkve6bKNdnlGJgAkWrNL8Zf0wmR2CiICxZuKOpcvnrU69j9Pt3E6jg4oOEkTzqmkIuzxbswdMfdQvjiMKsaM2vN0NY9K5iaN0BiZYALohLi47b2X+y/mFq4afPTxgPOIg1GKII2Ga63AKKzHBJQnHMuJWlBoT4k16nl+XtbjDyo/9oyCyp8dAiO4+vzI8xSjxPA0oq5WiiWAZscW9IoU3OAyMXi9SXiravHj21ffjtdo08kQ5Ieo3eG5qWUQ8eSEdDktb1W1vaq8ZpfEUqEKkvYntP8EKkAvb1w8+stBozLJQ+raqzzeWcDuTzaAKqygC9ubktBj/cBQTadNyeOzkD3MuXWeT6qvKy06jbWpv1eJTjAEk3fQguw3OKJ7CIadGa7PFxCKIPZl7j/xUlZuHamac1zF/VJS1Oq8PNzodbbizJ//K1L4IO7UwANf3m6p8YGF/blmKThR5SaJpUdSV529zY6cdbb3jExMSCwsGe0hlkQjCdLsN91C15+U5sR2XnV8MBup0tCiwJXmTEB4L8avUrJkjDLnxRt/F4v5ujtPabaNjY4kATIs2Y1f2u9TrI8DB2SMXTHGT0+FeS2/d4ynlvWT4hLKSq4M6EiUSQkUwyMMzEUIT+w/Ykr0xjlMeDM3U/UkCGFYxp4GbzEbf0FkbJ5DSFIHyJuQfGo+RAnZyCPXOzCvNsVBiPK2sjl6Xm2vmZ3qT583d3YdTBEAzQtLIIVPGuTGEmj6ZQw6UpkgMBcjwAPrA19qUcuvL6+9EIIbjRqJ63tCjeXPmHr1U6MuJd4CayLXK8g9/Q6HAwF28ZIowsqwg0Mwwg0TVJNCSyDSqaFkSoEgAGH+bAH+hGWmKYVEv7LYbdmMPf+sQ/uaEULte4/pt/0GjZvX8259fI0qYIRpi2B0AAAAASUVORK5CYII="
                  alt="支付宝"
                  style="display: block; width: 30px; height: 30px"
                />
              </div>
              <div class="MuiBox-root jss244 jss205">
                <div style="display: flex; align-items: center">
                  支付宝（1） <span class="jss217">推荐</span>
                </div>
              </div>
            </li> -->
            <!--关闭支付宝支付-->
            <div style="display: none">
              <li
                  class="MuiListItem-root jss203"
                  :class="isispayment == 5 ? 'jss211' : ''"
                  @click="ZFBPCpayment"
              >
                <div class="MuiBox-root jss243 jss204">
                  <img
                      src="data:image/png;base64,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"
                      alt="支付宝"
                      style="display: block; width: 30px; height: 30px"
                  />
                </div>
                <div class="MuiBox-root jss244 jss205">
                  <div style="display: flex; align-items: center">
                    支付宝<span class="jss217">推荐</span>
                  </div>
                </div>
              </li>

            </div>
            <!--关闭支付宝当面付-->
            <div style="display: none">
              <li
                  class="MuiListItem-root jss203"
                  :class="isispayment == 3 ? 'jss211' : ''"
                  @click="ZFBDpayment"
              >
                <div class="MuiBox-root jss243 jss204">
                  <img
                      src="data:image/png;base64,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"
                      alt="支付宝"
                      style="display: block; width: 30px; height: 30px"
                  />
                </div>
                <div class="MuiBox-root jss244 jss205">
                  <div style="display: flex; align-items: center">
                    支付宝扫码
                  </div>
                </div>
              </li>
            </div>

            <div>
              <li
                  class="MuiListItem-root jss203"
                  :class="isispayment == 7 ? 'jss211' : ''"
                  @click="WXpayment(7)"
              >
                <div class="MuiBox-root jss251 jss204">
                  <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAA+VBMVEUAAAA8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDX///89sDYtqib9/v07rzQvqyc6rzI+sTcwrCk3rzDW7dQzrCsrqSNGsz4kphz1+/W947t1xXA2ri/5/fnv+O6M0ImEzIByxG5tw2fq9uno9ebk8+PZ79jE5cKi2J+KzoVUt05Pt0k1rC7y+vLx+PDg8t6y37Co26Wc1Zh5x3NivlxevFhOtkfs9+vd8NyR0IyHzYKCzH59yXlYulNMtURCsjs1ri3O6szH58W137IipRnR7M/P6s/A5L5nwGK34LSv3qyU0pGT05CS0Y4NngQMnQFndLFBAAAADHRSTlMA/fiVjwbXKizUvbs+Ync0AAACjklEQVRIx5WW53raMBRAIRCStJaE98SAB2HvHTYBmqT7/R+myAYPLBp8foA+W8e6uta1lMA8pDN31CfcZdIPCZf7VJK6iWTq3un/lbqZL9hIUTFIHeNPxhGSD4k0FYt0IhNPyCS8fHIsg+iGvTTN4WjSkiWKI2Y3cW5BiRnX3koaACCrlauzibzlIME4CVCQG702CFAaKDINrwlQ4M0puKBrMyy8IuSlWhZE0AxskAQa/QQksnNEFDjeLuD7ncGw6vQDolkvO2OMGI4gCPQ3gKmrB+UZN6ZN9bAAmF1egFEBWdmToLpCaaKqrgB0BGFEYHoAuCHpVbclLubHkArlSmWm8i0WwrBAvwEC4kC3lkbdGis8z8KQsKmACC/DsfFeLra1QvulZ7cYGv5f6DWM50B630cyC30BJylMv7ELXyiaOKzApMPkGmLkHc4Q66dVD6+L0jjn/E/dy4WO86sj6L+415AwmDvP7K8NDev6quqkYSPAkwCZj0IwXsvx282/zAuO7/DHApi5zHmrFdUDQb3qRXcmdh8/p/N76M6o2mI9QUC/fOP74tTOXtSHsg0UEFp6ef9hAiLPaylQoqzaByf2yyxRqGxaASHPiceEVHD0olUkCnue9gUODcG01qQa1qxmTERi+dkM5wt0vtZvypLAI1lGcp0k5CSaCgjcWsIrEuJvkZCvggjdJg99AQ/BUmc4fi1GUjRC3uKLApnJ7qKaVoxXD0RDoo1ucMK6Cq8Lbpplxcx1i5rWLuf2HVBDwRIlK1skKavRx1iR0ConKnkYEMgGx255xPASS6OW3RQiI5CcMwLv5RBvKDcD8YaSiSc8xd8UH+Ntu49xN/bYR4f4h5Nbjz/Ju6f0I+77D4WTlAJcIT+FAAAAAElFTkSuQmCC"
                      alt="微信支付"
                      style="display: block; width: 30px; height: 30px"
                  />
                </div>
                <div class="MuiBox-root jss244 jss205">
                  <div style="display: flex; align-items: center">
                    微信支付<span class="jss217">推荐</span>
                  </div>
                </div>

              </li>
            </div>
            <!-- 关闭微信支付 -->
            <div style="display: none">
              <li
                  class="MuiListItem-root jss203"
                  :class="isispayment == 2 ? 'jss211' : ''"
                  @click="WXpayment"
              >
                <div class="MuiBox-root jss251 jss204">
                  <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAA+VBMVEUAAAA8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDX///89sDYtqib9/v07rzQvqyc6rzI+sTcwrCk3rzDW7dQzrCsrqSNGsz4kphz1+/W947t1xXA2ri/5/fnv+O6M0ImEzIByxG5tw2fq9uno9ebk8+PZ79jE5cKi2J+KzoVUt05Pt0k1rC7y+vLx+PDg8t6y37Co26Wc1Zh5x3NivlxevFhOtkfs9+vd8NyR0IyHzYKCzH59yXlYulNMtURCsjs1ri3O6szH58W137IipRnR7M/P6s/A5L5nwGK34LSv3qyU0pGT05CS0Y4NngQMnQFndLFBAAAADHRSTlMA/fiVjwbXKizUvbs+Ync0AAACjklEQVRIx5WW53raMBRAIRCStJaE98SAB2HvHTYBmqT7/R+myAYPLBp8foA+W8e6uta1lMA8pDN31CfcZdIPCZf7VJK6iWTq3un/lbqZL9hIUTFIHeNPxhGSD4k0FYt0IhNPyCS8fHIsg+iGvTTN4WjSkiWKI2Y3cW5BiRnX3koaACCrlauzibzlIME4CVCQG702CFAaKDINrwlQ4M0puKBrMyy8IuSlWhZE0AxskAQa/QQksnNEFDjeLuD7ncGw6vQDolkvO2OMGI4gCPQ3gKmrB+UZN6ZN9bAAmF1egFEBWdmToLpCaaKqrgB0BGFEYHoAuCHpVbclLubHkArlSmWm8i0WwrBAvwEC4kC3lkbdGis8z8KQsKmACC/DsfFeLra1QvulZ7cYGv5f6DWM50B630cyC30BJylMv7ELXyiaOKzApMPkGmLkHc4Q66dVD6+L0jjn/E/dy4WO86sj6L+415AwmDvP7K8NDev6quqkYSPAkwCZj0IwXsvx282/zAuO7/DHApi5zHmrFdUDQb3qRXcmdh8/p/N76M6o2mI9QUC/fOP74tTOXtSHsg0UEFp6ef9hAiLPaylQoqzaByf2yyxRqGxaASHPiceEVHD0olUkCnue9gUODcG01qQa1qxmTERi+dkM5wt0vtZvypLAI1lGcp0k5CSaCgjcWsIrEuJvkZCvggjdJg99AQ/BUmc4fi1GUjRC3uKLApnJ7qKaVoxXD0RDoo1ucMK6Cq8Lbpplxcx1i5rWLuf2HVBDwRIlK1skKavRx1iR0ConKnkYEMgGx255xPASS6OW3RQiI5CcMwLv5RBvKDcD8YaSiSc8xd8UH+Ntu49xN/bYR4f4h5Nbjz/Ju6f0I+77D4WTlAJcIT+FAAAAAElFTkSuQmCC"
                      alt="微信支付"
                      style="display: block; width: 30px; height: 30px"
                  />
                </div>
                <div class="MuiBox-root jss252 jss205">
                  <div style="display: flex; align-items: center">微信</div>
                </div>
              </li>
            </div>
            <!---->
            <!-- 关闭畅想支付 -->
            <div style="display: none">
              <li
                  class="MuiListItem-root jss203"
                  :class="isispayment == 1 ? 'jss211' : ''"
                  @click="ZFBpayment"
              >
                <div class="MuiBox-root jss243 jss204">
                  <img
                      src="data:image/png;base64,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"
                      alt="支付宝"
                      style="display: block; width: 30px; height: 30px"
                  />
                </div>
                <div class="MuiBox-root jss244 jss205">
                  <div style="display: flex; align-items: center">畅想支付</div>
                </div>
              </li>
            </div>
          </ul>
        </div>
        <div class="jss208">
          <div class="jss253">
            <div class="MuiBox-root jss285">
              <div v-if="isispayment == 2 || isispayment == 7" class="MuiBox-root jss286 jss271">
                <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAA+VBMVEUAAAA8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDU8sDX///89sDYtqib9/v07rzQvqyc6rzI+sTcwrCk3rzDW7dQzrCsrqSNGsz4kphz1+/W947t1xXA2ri/5/fnv+O6M0ImEzIByxG5tw2fq9uno9ebk8+PZ79jE5cKi2J+KzoVUt05Pt0k1rC7y+vLx+PDg8t6y37Co26Wc1Zh5x3NivlxevFhOtkfs9+vd8NyR0IyHzYKCzH59yXlYulNMtURCsjs1ri3O6szH58W137IipRnR7M/P6s/A5L5nwGK34LSv3qyU0pGT05CS0Y4NngQMnQFndLFBAAAADHRSTlMA/fiVjwbXKizUvbs+Ync0AAACjklEQVRIx5WW53raMBRAIRCStJaE98SAB2HvHTYBmqT7/R+myAYPLBp8foA+W8e6uta1lMA8pDN31CfcZdIPCZf7VJK6iWTq3un/lbqZL9hIUTFIHeNPxhGSD4k0FYt0IhNPyCS8fHIsg+iGvTTN4WjSkiWKI2Y3cW5BiRnX3koaACCrlauzibzlIME4CVCQG702CFAaKDINrwlQ4M0puKBrMyy8IuSlWhZE0AxskAQa/QQksnNEFDjeLuD7ncGw6vQDolkvO2OMGI4gCPQ3gKmrB+UZN6ZN9bAAmF1egFEBWdmToLpCaaKqrgB0BGFEYHoAuCHpVbclLubHkArlSmWm8i0WwrBAvwEC4kC3lkbdGis8z8KQsKmACC/DsfFeLra1QvulZ7cYGv5f6DWM50B630cyC30BJylMv7ELXyiaOKzApMPkGmLkHc4Q66dVD6+L0jjn/E/dy4WO86sj6L+415AwmDvP7K8NDev6quqkYSPAkwCZj0IwXsvx282/zAuO7/DHApi5zHmrFdUDQb3qRXcmdh8/p/N76M6o2mI9QUC/fOP74tTOXtSHsg0UEFp6ef9hAiLPaylQoqzaByf2yyxRqGxaASHPiceEVHD0olUkCnue9gUODcG01qQa1qxmTERi+dkM5wt0vtZvypLAI1lGcp0k5CSaCgjcWsIrEuJvkZCvggjdJg99AQ/BUmc4fi1GUjRC3uKLApnJ7qKaVoxXD0RDoo1ucMK6Cq8Lbpplxcx1i5rWLuf2HVBDwRIlK1skKavRx1iR0ConKnkYEMgGx255xPASS6OW3RQiI5CcMwLv5RBvKDcD8YaSiSc8xd8UH+Ntu49xN/bYR4f4h5Nbjz/Ju6f0I+77D4WTlAJcIT+FAAAAAElFTkSuQmCC"
                    alt=""
                    style="width: 50px; height: 50px; margin-right: 20px"
                />
                <h4
                    class="
                    MuiTypography-root
                    MuiTypography-h4
                    MuiTypography-colorTextPrimary
                  "
                >
                  微信支付
                </h4>
              </div>
              <div v-if="isispayment == 1" class="MuiBox-root jss286 jss271">
                <img
                    src="data:image/png;base64,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"
                    alt=""
                    style="width: 50px; height: 50px; margin-right: 20px"
                />
                <h4
                    class="
                    MuiTypography-root
                    MuiTypography-h4
                    MuiTypography-colorTextPrimary
                  "
                >
                  畅想支付
                </h4>
              </div>
              <div
                  v-if="isispayment == 3 || isispayment == 4 || isispayment == 5"
                  class="MuiBox-root jss286 jss271"
              >
                <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAACqVBMVEUAAAAAqu8Am9oAqu8Aqu8BltQBlNQAoeIBnt4BltMBltQAoeIBnt4BltQAqu8Aqu8Aqu8AoeIBnt4Aqu8Aqu////8BltT///0Aqu4CqvABnt7///sAq+8AoeIApev///kAqvEApe8Ep+vt+vwAq/Cw5PIut+0AqfAApe0ApO/8/vv+//4Bp/EAo/AAqe8Bq+0ApO0Ap+8AqO0Aq/JJvvABqu3//f7+/v37/v0ArOv//vz3/Pv///j9/vid3vfm9vUBqe4AquwApOn//v/9//zy+fgAp/QApPQAofIAoe4Ao+sAoOskr+f9///9/f70/PyX3fW+6PIApfK25PEApPFIvvAAre5gxe0ZqOhFvuXg4eDz+/vy+/n0+/jr9/j4/ffY8PTH6/Sy4vMAqvOo4fCc2+6P1ew1tewArewhresDqes1uOoqr+oLqOo6tul9zugTrOcMp+cCpucBouX8///3/f38/Pzv+fro9vn6/vjk9ffK6/bh8/XN6vS35vKi3vIAqPLC6PEArfGA0e4Tq+1kyOxbw+wZrOwJp+x50OsgsusLrOsAoutDveqB0eluyOlHvelmw+css+cRqecAn+br+frc8vkAqPXa8fTN7/PQ7vMBqfOt5fKr4PLK6/GP0/EAnvGy5fCK1vAArfCw4O8Ane+I1e5Mv+5Cu+1Iuu0FqO2U1ux4yOtUxOtQvutIvOs/uOsksusEresAp+tGv+ovuOpFt+pLwekMpOloyugvtugys+iFz+dexedQwuZJu+YNq+YAq+ZPveUKp+IAouIssOH9+/oAovre9PWb3/Xs9vTC6/MAm/PT6vGT3fE4uO+03u6M2+0Mp+2u4uyNzeyX2euQ1+tgwuur3+ql2+p0zeqL0+UCo+M1t+JaweDK2dyzzNgSl9IroM131JcAAAAAFHRSTlMA/SuVBpD8+fj02NfX1L27mI+OCXGCc30AAATCSURBVEjHlZaFd9NAHMeLu99xCRciEEgqq9JV1tK1c2fCBHef4+7u7u7u7u7uDn8Jl3ZjdN0D+nl9fS/fd5/kd7kkv1Mp1G7dtGG7f9CwaevaqgB169QC/0Wtlm3841uA/6Z5XSLUAWFQh9RfKxyhVm1Vq5py2SjLRhOgQAj1VE1CMsvBRUXLly+5tpCpQWisahCSGYSRnt5xcVHFyXSoUF/VPiQbpj/mRgjBy0l86CXaVgoMA6gKGHn/GKS1oaVmuiIBDkN1gUDzdABeXhIFYSSaJU+vTCw8iA4WGEnXoZIRvuNE0MLLt39HZR0AEyRIJ4VnnSrZPChzLIQI9xv0O9pxThCDBN1J+fSajpWM6+nWwjRNVFUSdyHHwvwpUIx1UedKzqxc4S/p0KjfydDZdPAcqJnWaJOcoBYIanb7yN4IpsEF27MEBVY2ySZRX+0u6YHFcooNsKeoF7lLsHh14NDH8mRB6GoCoE6deDOtq8KDpwM0EELuyeCuXbspvEjViTWsg1D0MFbjZ8KYnhkZGT3H2Cf05TDG3Pr86VSoQEslB/Z1qaC7Qpd9BV8nK5cakghqEKhcJlmdExGhDvzUyt/js30RhBnXEnhQXZCsosNnFNRq2Szrd9H0Jl5iRImdxsXGwEkl0frqAjVsXeL8E8cLCgqKRq1i1ayZsXoNBuGiBzmdeFaEeXp1wZQ8/EL22nG9e/bqs3bSoAXnFnZIyjHpkve6bKNdnlGJgAkWrNL8Zf0wmR2CiICxZuKOpcvnrU69j9Pt3E6jg4oOEkTzqmkIuzxbswdMfdQvjiMKsaM2vN0NY9K5iaN0BiZYALohLi47b2X+y/mFq4afPTxgPOIg1GKII2Ga63AKKzHBJQnHMuJWlBoT4k16nl+XtbjDyo/9oyCyp8dAiO4+vzI8xSjxPA0oq5WiiWAZscW9IoU3OAyMXi9SXiravHj21ffjtdo08kQ5Ieo3eG5qWUQ8eSEdDktb1W1vaq8ZpfEUqEKkvYntP8EKkAvb1w8+stBozLJQ+raqzzeWcDuTzaAKqygC9ubktBj/cBQTadNyeOzkD3MuXWeT6qvKy06jbWpv1eJTjAEk3fQguw3OKJ7CIadGa7PFxCKIPZl7j/xUlZuHamac1zF/VJS1Oq8PNzodbbizJ//K1L4IO7UwANf3m6p8YGF/blmKThR5SaJpUdSV529zY6cdbb3jExMSCwsGe0hlkQjCdLsN91C15+U5sR2XnV8MBup0tCiwJXmTEB4L8avUrJkjDLnxRt/F4v5ujtPabaNjY4kATIs2Y1f2u9TrI8DB2SMXTHGT0+FeS2/d4ynlvWT4hLKSq4M6EiUSQkUwyMMzEUIT+w/Ykr0xjlMeDM3U/UkCGFYxp4GbzEbf0FkbJ5DSFIHyJuQfGo+RAnZyCPXOzCvNsVBiPK2sjl6Xm2vmZ3qT583d3YdTBEAzQtLIIVPGuTGEmj6ZQw6UpkgMBcjwAPrA19qUcuvL6+9EIIbjRqJ63tCjeXPmHr1U6MuJd4CayLXK8g9/Q6HAwF28ZIowsqwg0Mwwg0TVJNCSyDSqaFkSoEgAGH+bAH+hGWmKYVEv7LYbdmMPf+sQ/uaEULte4/pt/0GjZvX8259fI0qYIRpi2B0AAAAASUVORK5CYII="
                    alt=""
                    style="width: 50px; height: 50px; margin-right: 20px"
                />
                <h4
                    class="
                    MuiTypography-root
                    MuiTypography-h4
                    MuiTypography-colorTextPrimary
                  "
                >
                  支付宝
                </h4>
              </div>
              <p style="color: red" class="topupHints" v-if="isispayment == 5">
                若该支付通道无法支付，请尝试使用其他支付通道
              </p>
              <p class="topupHints">充值将在十分钟内到账,超时未到账请联系客服</p>

              <div class="jss258">
                <!-- 微信 -->
                <div
                    class="jss259"
                    v-for="(item, index) in paymentNumberwx"
                    :key="index"
                    v-if="isispayment == 2"
                >
                  <button
                      tabindex="0"
                      type="button"
                      class="MuiButtonBase-root jss256"
                      @click="choiceDoublewx(index, item)"
                      :class="{ jss263: index == paymencurrentswx }"
                  >
                    <!-- <div class="topupHints_add">多送{{(item * 0.13).toFixed(2) }}心币</div> -->
                    <div class="topupHints_add">C 币</div>
                    <div class="jss265">
                      <img src="../assets/logo.png" alt=""/>
                    </div>
                    <div>
                      <p
                          class="MuiTypography-root MuiTypography-body1"
                          style="font-size: 26px"
                      >
                        {{ item }} <span></span>
                      </p>
                      <p style="bottom: 8px">
                        ≈￥{{ (item * 6.7).toFixed(2) }}
                      </p>
                    </div>
                  </button>
                </div>
                <div
                    class="jss259"
                    v-for="(item, index) in paymentNumberwx"
                    :key="index"
                    v-if="isispayment == 7"
                >
                  <button
                      tabindex="0"
                      type="button"
                      class="MuiButtonBase-root jss256"
                      @click="choiceDoublewx(index, item)"
                      :class="{ jss263: index == paymencurrentswx }"
                  >
                    <!-- <div class="topupHints_add">多送{{(item * 0.13).toFixed(2) }}心币</div> -->
                    <div class="topupHints_add">C 币</div>
                    <div class="jss265">
                      <img src="../assets/logo.png" alt=""/>
                    </div>
                    <div>
                      <p
                          class="MuiTypography-root MuiTypography-body1"
                          style="font-size: 26px"
                      >
                        {{ item }} <span></span>
                      </p>
                      <p style="bottom: 8px">
                        ≈￥{{ (item * 6.7).toFixed(2) }}
                      </p>
                    </div>
                  </button>
                </div>
                <!-- 支付宝 -->
                <div
                    class="jss259"
                    v-for="(item, index) in paymentNumberzfb"
                    :key="index"
                    v-if="isispayment == 1"
                >
                  <button
                      tabindex="0"
                      type="button"
                      class="MuiButtonBase-root jss256"
                      @click="choiceDoublezfb(index, item)"
                      :class="{ jss263: index == paymencurrentszfb }"
                  >
                    <!-- <div class="topupHints_add">多送{{(item * 0.13).toFixed(2) }}心币</div> -->
                    <div class="topupHints_add">C 币</div>
                    <div class="jss265">
                      <img src="../assets/logo.png" alt=""/>
                    </div>
                    <div>
                      <p
                          class="MuiTypography-root MuiTypography-body1"
                          style="font-size: 26px"
                      >
                        {{ item }} <span></span>
                      </p>
                      <p style="bottom: 8px">
                        ≈￥{{ (item * 6.7).toFixed(2) }}
                      </p>
                    </div>
                  </button>
                </div>
                <!-- 支付宝(虎皮椒) -->
                <div
                    class="jss259"
                    v-for="(item, index) in paymentNumberzfbhpj"
                    :key="index"
                    v-if="isispayment == 4"
                >
                  <button
                      tabindex="0"
                      type="button"
                      class="MuiButtonBase-root jss256"
                      @click="choiceDoublezfb(index, item)"
                      :class="{ jss263: index == paymencurrentszfb }"
                  >
                    <!-- <div class="topupHints_add">多送{{(item * 0.13).toFixed(2) }}心币</div> -->
                    <div class="topupHints_add">C 币</div>
                    <div class="jss265">
                      <img src="../assets/logo.png" alt=""/>
                    </div>
                    <div>
                      <p
                          class="MuiTypography-root MuiTypography-body1"
                          style="font-size: 26px"
                      >
                        {{ item }} <span></span>
                      </p>
                      <p style="bottom: 8px">
                        ≈￥{{ (item * 6.7).toFixed(2) }}
                      </p>
                    </div>
                  </button>
                </div>

                <!-- 支付宝当面付 -->
                <div
                    class="jss259"
                    v-for="(item, index) in paymentNumberzfbd"
                    :key="index"
                    v-if="isispayment == 3"
                >
                  <button
                      tabindex="0"
                      type="button"
                      class="MuiButtonBase-root jss256"
                      @click="choiceDoublezfbd(index, item)"
                      :class="{ jss263: index == paymencurrentszfbd }"
                  >
                    <!-- <div class="topupHints_add">多送{{(item * 0.13).toFixed(2) }}心币</div> -->
                    <div class="topupHints_add">C 币</div>
                    <div class="jss265">
                      <img src="../assets/logo.png" alt=""/>
                    </div>
                    <div>
                      <p
                          class="MuiTypography-root MuiTypography-body1"
                          style="font-size: 26px"
                      >
                        {{ item }} <span></span>
                      </p>
                      <p style="bottom: 8px">
                        ≈￥{{ (item * 6.7).toFixed(2) }}
                      </p>
                    </div>
                  </button>
                </div>
                <!-- 支付宝电脑支付 -->
                <div
                    class="jss259"
                    v-for="(item, index) in paymentNumberzfbd"
                    :key="index"
                    v-if="isispayment == 5"
                >
                  <button
                      tabindex="0"
                      type="button"
                      class="MuiButtonBase-root jss256"
                      @click="choiceDoublezfbd(index, item)"
                      :class="{ jss263: index == paymencurrentszfbd }"
                  >
                    <!-- <div class="topupHints_add">多送{{(item * 0.13).toFixed(2) }}心币</div> -->
                    <div class="topupHints_add">C 币</div>
                    <div class="jss265">
                      <img src="../assets/logo.png" alt=""/>
                    </div>
                    <div>
                      <p
                          class="MuiTypography-root MuiTypography-body1"
                          style="font-size: 26px"
                      >
                        {{ item }} <span></span>
                      </p>
                      <p style="bottom: 8px">
                        ≈￥{{ (item * 6.7).toFixed(2) }}
                      </p>
                    </div>
                  </button>
                </div>

                <!-- 其他数量 -->
                <!-- <div class="jss259" @click="definitionPayment">
                  <div
                    tabindex="0"
                    role="button"
                    aria-disabled="false"
                    class="MuiButtonBase-root jss256 definitionPayments"
                    style="height: 100%; box-sizing: border-box"
                  >
                    <div class="MuiBox-root jss288">其他数量(<span>Coins</span>)</div>
                    <div class="MuiBox-root jss902 jss900 jss867">
                      <button
                        tabindex="0"
                        type="button"
                        class="MuiButtonBase-root MuiButton-root MuiButton-text MuiBox-root jss903 jss899 MuiButton-textSizeSmall MuiButton-sizeSmall"
                      >
                        <span class="MuiButton-label" @click="definitionPaymentadd"
                          ><svg
                            focusable="false"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                          >
                            <path d="M19 13H5v-2h14v2z"></path></svg></span
                        ><span class="MuiTouchRipple-root"></span>
                      </button>
                      <div class="MuiBox-root jss904">
                        <div
                          class="MuiInputBase-root MuiInput-root MuiInputBase-fullWidth MuiInput-fullWidth"
                        >
                          <input
                            type="text"
                            class="MuiInputBase-input MuiInput-input jss901"
                            v-model="defPayment"
                          />
                        </div>
                      </div>
                      <button
                        tabindex="0"
                        type="button"
                        class="MuiButtonBase-root MuiButton-root MuiButton-text MuiBox-root jss905 jss899 MuiButton-textSizeSmall MuiButton-sizeSmall"
                      >
                        <span class="MuiButton-label" @click="definitionPaymentreduce" style="z-index:99999;"
                          ><svg
                            focusable="false"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                          >
                            <path
                              d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                            ></path></svg></span
                        ><span class="MuiTouchRipple-root"></span>
                      </button>
                    </div>
                  </div>
                </div> -->
              </div>

              <div
                  class="MuiBox-root jss297"
                  style="margin-top: 38px; height: 20px"
              ></div>
              <div class="MuiBox-root jss298"></div>
              <div class="MuiBox-root jss909" style="margin-top: 10px">
                <button
                    tabindex="0"
                    type="button"
                    underline="none"
                    id="btnAlipayDeposit"
                    class="
                    MuiButtonBase-root
                    MuiButton-root
                    MuiButton-contained
                    MuiButton-containedPrimary
                    MuiButton-containedSizeLarge
                    MuiButton-sizeLarge
                  "
                    style="min-width: 130px; position: relative"
                    @click="recharge"
                >
                  <span class="MuiButton-label" v-if="isrepages"
                  >请求中<i class="el-icon-loading"></i
                  ></span>
                  <span class="MuiButton-label" v-else>立即充值</span>
                  <span class="MuiTouchRipple-root"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 充值页面 -->
      <div v-show="isrepage" class="repage">
        <div class="repage_title">
          <p>订单支付</p>
          <!-- <span @click="outqr()">X</span> -->
          <i
              @click="outqr()"
              class="iconfont icon-guanbi"
              style="
              font-size: 24px;
              font-weight: bold;
              color: #bdbdbd;
              cursor: pointer;
            "
          ></i>
        </div>
        <div class="repage_data">
          <p>购买账号:{{ this.$store.state.userdata.username }}</p>
          <div class="repage_data_logo">
            <img :src="this.$store.state.userdata.logo" alt=""/>
            <p>{{ defPayment }} <span>Coins</span></p>
          </div>
        </div>
        <div class="repage_img">
          <p>支付方式:</p>
          <div class="repage_img_data">
            <p v-if="isispayment == 2 || isispayment == 7">
              微信扫码支付,支付<span>{{ pay_price }}</span
            >元
            </p>
            <p v-else>
              支付宝扫码支付,支付<span>{{ pay_price }}</span
            >元
            </p>
            <img
                v-if="qrcode_src"
                :src="qrcode_src"
                alt=""
                width="150"
                height="150"
            />
            <div v-if="!qrcode_src" id="qrcode" ref="qrcode">
              <!-- <img src="../assets/img/logo.6a88e67b.png" alt=""> -->
            </div>
            <p></p>
            <el-button type="primary" @click="outrepage">完成支付</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 红包 -->
    <Redenvelopes></Redenvelopes>
  </div>
</template>

<script>
import Redenvelopes from "../components/Redenvelopes";
import QRCode from "qrcodejs2";

export default {
  components: {
    Redenvelopes,
    QRCode,
  },
  data() {
    return {
      ispayment: false, //支付方式
      isispayment: 7, //判断是那种支付方式
      paymentNumberzfbd: ["5", "10", "30", "50", "100", "300", "500"],
      paymentNumberwx: ["5", "10", "30", "50", "100", "300", "500"],
      paymentNumberzfb: ["5", "10", "30", "50", "100", "300", "500"],
      paymentNumberzfbhpj: ["5", "10", "30", "50", "100", "300", "500"],
      paymentNumberzfPc: ["5", "10", "30", "50", "100", "300", "500"],
      paymencurrentswx: "0", //充值的价位
      paymencurrentszfb: "0", //充值的价位
      paymencurrentszfbd: "0", //充值的价位
      paymentcurrentszfbhpj: "0",
      paymentcurrentszfPc: "0",
      defPayment: "5", //自定义价钱
      isrepage: false, //充值页面
      isrepages: false, //充值加载
      pay_price: "", //充值多少
      qrcode: null, //二维码地址
      qrcode_src: null,
      order: "", //订单编号
      interval: null, //循环查询是否支付
    };
  },
  methods: {
    // 红包
    redPrize() {
      document.getElementsByClassName("ivu-modal")[0].style.display = "block";
      document.getElementById("isquan").classList.add("backghui");
    },
    //微信jss263
    WXpayment(isispayment = 2, defPayment = 5) {
      // document.getElementsByClassName('MuiListItem-root')[0].classList.add('jss211');
      // document.getElementsByClassName('MuiListItem-root')[1].classList.remove('jss211')
      // this.ispayment = true
      this.isispayment = isispayment;
      this.defPayment = defPayment;
      this.paymencurrentswx = 0;
    },
    //zfb
    ZFBpayment() {
      // document.getElementsByClassName('MuiListItem-root')[1].classList.add('jss211');
      // document.getElementsByClassName('MuiListItem-root')[0].classList.remove('jss211')
      // this.ispayment = false
      this.isispayment = 1;
      this.defPayment = 5;
      this.paymencurrentszfb = 0;
    },
    //zfbd
    ZFBDpayment() {
      this.defPayment = 5;
      this.paymencurrentszfbd = 0;
      this.isispayment = 3;
    },
    ZFBHPJpayment() {
      this.isispayment = 4;

      this.defPayment = 5;
      this.paymencurrentszfbd = 0;
    },
    ZFBPCpayment() {
      this.defPayment = 5;
      this.paymencurrentszfbd = 0;
      this.isispayment = 5;
    },
    //确定充值的价位wx
    choiceDoublewx(index, item) {
      this.paymencurrentswx = index;
      // document.getElementsByClassName('definitionPayments')[0].classList.remove('jss263')
      // console.log(item);
      this.defPayment = item;
    },
    //确定充值的价位zfb
    choiceDoublezfb(index, item) {
      this.paymencurrentszfb = index;
      // document.getElementsByClassName('definitionPayments')[0].classList.remove('jss263')
      // console.log(item);
      this.defPayment = item;
    },
    //确定充值的价位zfbd
    choiceDoublezfbd(index, item) {
      this.paymencurrentszfbd = index;
      // document.getElementsByClassName('definitionPayments')[0].classList.remove('jss263')
      // console.log(item);
      this.defPayment = item;
    },
    //选择自定义充值
    definitionPayment() {
      this.paymencurrents = null;
      document
          .getElementsByClassName("definitionPayments")[0]
          .classList.add("jss263");
    },
    //减
    definitionPaymentadd() {
      this.defPayment--;
    },
    //加
    definitionPaymentreduce() {
      this.defPayment++;
    },
    //充值按钮
    recharge() {
      this.qrcode_src = null;
      // console.log(this.isispayment);//1微信 2支付宝
      // console.log(this.defPayment);//充值数量
      if (!this.isrepages) {
        this.isrepages = true;
        this.$axios({
          url: "pay/pay",
          method: "post",
          data: {
            price: this.defPayment,
            type: this.isispayment,
          },
        }).then((res) => {
          if (this.isispayment != 5) {
            if (
                res.data.code == 200 ||
                res.data.status == 200 ||
                res.data.code == 10000 ||
                res.data.code == 10001
            ) {
              //虎皮椒支付
              if (res.data.code == 10001) {
                this.pay_price = this.defPayment * 6.7;
                this.order = res.data.out_trade_no;
                this.qrcode_src = res.data.url_qrcode;
                //展示扫码页面
                this.isrepage = true;
                this.isrepages = false;
              }
              //如果是支付宝当面付的话  是没有订单金额还回的  直接拿传的金额*6.7
              if (res.data.code == 10000) {
                this.pay_price = this.defPayment * 6.7;
                this.order = res.data.out_trade_no;
                //生成二维码
                this.$nextTick(() => {
                  this.makeQrcode(res.data.qr_code);
                });
              } else if (res.data.code != 10001) {
                this.pay_price = res.data.data.pay_price / 100;
                this.order = res.data.data.out_order_sn;
                //生成二维码
                this.$nextTick(() => {
                  this.makeQrcode(res.data.data.qr);
                });
              }
              //展示扫码页面
              this.isrepage = true;
              this.isrepages = false;
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
              this.isrepages = false;
            }
          } else {
            if (res.status == 200) {
              console.log(res.data);

              var body = document.getElementsByTagName("body")[0];
              var div = document.createElement("div");

              body.appendChild(div);
              div.innerHTML = res.data;

              document.forms["alipaysubmit"].submit();
            } else {
              this.$message({
                showClose: true,
                message: res.status,
                type: "error",
              });
              this.isrepages = false;
            }
          }
        });
      }
    },
    //关闭充值扫码页面 重新请求一遍数据
    outrepage() {
      this.$axios({
        url: "pay/get/succ",
        method: "post",
        data: {
          order_id: this.order,
        },
      }).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "success",
          });
          //支付成功后关闭页面
          this.outqr();
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //循环查询用户是否支付
    getinterval() {
      this.$axios({
        url: "pay/get/succ",
        method: "post",
        data: {
          order_id: this.order,
        },
      }).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "success",
          });
          //支付成功后关闭页面
          this.outqr();
        }
      });
    },
    //关闭二维码支付页面
    outqr() {
      this.isrepage = false;
      this.isrepages = false;
    },
    //支付二维码
    makeQrcode(text) {
      if (this.qrcode) {
        this.qrcode.clear();
        this.qrcode.makeCode(text);
      } else {
        this.qrcode = new QRCode("qrcode", {
          width: 150, // 设置宽度，单位像素
          height: 150, // 设置高度，单位像素
          text, // 设置二维码内容或跳转地址
        });
      }
    },
    //登录
    handleZhu() {
      document.getElementsByClassName("form-wnd")[0].classList.add("active");
      document.getElementsByClassName("popup-bg")[0].classList.add("active");
      document
          .getElementsByClassName("switch-block")[0]
          .classList.add("active");
      document
          .getElementsByClassName("switch-block")[1]
          .classList.remove("active");
      document.getElementsByClassName("button")[0].classList.add("active");
      document.getElementsByClassName("button")[1].classList.remove("active");
      this.isBar = false;
      this.password = "";
    },
  },
  watch: {
    //实现轮询
    isrepage() {
      if (this.isrepage) {
        this.interval = window.setInterval(() => {
          setTimeout(this.getinterval(), 0);
        }, 3000);
      } else {
        //清除轮询
        clearInterval(this.interval);
        this.interval = null;
      }
    },
  },
  beforeDestroy() {
    //清除轮询
    clearInterval(this.interval);
    this.interval = null;
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$message({
        showClose: true,
        message: "请先登录",
      });
      this.$router.push("/");
      //提示登录框
      setTimeout(() => {
        this.handleZhu();
      }, 300);
    }
  },
};
</script>

<style scoped lang='less'>
@import url("../assets/csscopy/recharge.css");

.repage {
  width: 700px;
  margin: 0 auto;
  position: fixed;
  left: calc(50% - 350px);
  top: 22%;

  .repage_title {
    border-bottom: 1px solid #d8d8d8;
    background-color: #f4f4f4;
    display: flex;
    color: #000;
    padding: 0 15px;
    align-items: center;

    p {
      flex: 1;
      padding: 5px 0;
      font-size: 18px;
      text-align: center;
    }

    span {
      align-items: center;
      color: #bdbdbd;
      cursor: pointer;
    }
  }

  .repage_data {
    padding: 3% 10%;
    background-color: #f9f9f9;
    border-bottom: 1px #d8d8d8 solid;

    p {
      color: #313131;
      padding-bottom: 20px;
    }

    .repage_data_logo {
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        width: 100px;
        height: 100px;
        border-radius: 10px;
      }

      p {
        font-size: 35px;
        font-weight: 600;
      }

      span {
        font-size: 20px;
      }
    }
  }

  .repage_img {
    padding: 3% 10%;
    background-color: #ffffff;
    color: #313131;

    p {
      font-size: 15px;
    }

    .repage_img_data {
      text-align: center;

      div {
        display: flex;
        justify-content: center;
      }

      span {
        font-size: 25px;
      }

      button {
        margin-top: 20px;
      }
    }
  }
}

// 隐藏金币图片
// .jss265{
//   display: none;
// }
//充值提示
.topupHints {
  font-size: 20px;
  text-align: center;
  color: #c3c3e2;
}

//去除充值按钮padding值
.recharge .jss256 {
  padding: 0;
}

//充值头部
.topupHints_add {
  width: 100%;
  color: #000;
  background-color: #02bf4d;
  line-height: 25px;
  font-size: 12px;
}

.recharge .jss259 {
  width: 120px;
  margin-left: 10px;
}

@media screen and (max-width: 800px) {
  .recharge {
    width: 100% !important;
  }

  .jss259 {
    margin: 1%;
    width: 31%;
  }

  .repage {
    width: 100%;
    left: 0;
    padding: 0 10px;
  }
}
</style>
